import { ELanguage, RecommendJobs } from '@microfrontends/react-components'
import { useContext } from 'react'
import AppContext from '../../context/AppContext'
import { decrypt } from '../../services/auth/cryptorNode'
import { RecommendJobsWrap } from './index.css'
import { IUser } from '../../services/auth/@type'
import { useInitialData } from '@microfrontends/app-shell-v2'

const API_URL = `${process.env.API_DOMAIN}/smartnavi/v2/jobs`
const VNW_BASE_URL = `${process.env.APP_BASE_URL}/` ?? ''

interface IProps {
	utm: {
		utm_source: string
		utm_medium: string
		utm_campaign: string
	}
	handleNoJobs?: () => void
}

export default function RecommendJobsSlide({ utm, handleNoJobs }: IProps) {
	const { user, userIP, languageCode } = useContext(AppContext)
	const token = decrypt(user?.accessToken || '')
	const userInfo:
		| (Omit<IUser, 'jobLevelId'> & { joblevelId: number })
		| undefined = user?.jobLevelId
		? {
				...user,
				joblevelId: user?.jobLevelId[0]
		  }
		: undefined
	const initData = useInitialData(languageCode ?? ELanguage.VI)

	return (
		<RecommendJobsWrap>
			<RecommendJobs
				key={`key-${token}`}
				user={user && user?.userId ? String(user?.userId) : ''}
				userIP={userIP}
				languageCode={languageCode === ELanguage.EN ? 2 : 1}
				limit={200}
				apiUrl={API_URL}
				vnwBaseURL={VNW_BASE_URL}
				utmData={utm}
				hasSalary
				handleNoJobs={() => {
					handleNoJobs?.()
				}}
				previewJob={{
					enablePreviewJob: true,
					accessToken: token,
					msUrl: process.env.API_DOMAIN || ''
				}}
				classSelector='top_recommend view_job_item'
				userInfo={userInfo as any}
				initData={initData}
			/>
		</RecommendJobsWrap>
	)
}
